import { DEMO_PERSONAS, type DemoPersona, demoLogin } from '@shkola/api';
import { useEffect, useRef } from 'react';
import { readEnv } from '../env';
import { useAuth } from './AuthProvider';

const isPersona = (value: string | null): value is DemoPersona =>
  value !== null && (DEMO_PERSONAS as ReadonlyArray<string>).includes(value);

/**
 * Demo stacks: `/?demo=student` signs in as that persona, switching from whoever is signed in,
 * and drops the parameter from the address — one link for a teammate into the right role.
 * Never in production (the Edge Function does not exist there).
 */
export function DemoLink() {
  const { supabase, step, signOut } = useAuth();
  const handled = useRef(false);
  useEffect(() => {
    if (handled.current || step === 'loading') return;
    if (readEnv(import.meta.env as Record<string, string | undefined>).appEnv === 'production')
      return;
    const url = new URL(window.location.href);
    const persona = url.searchParams.get('demo');
    if (!isPersona(persona)) return;
    handled.current = true;
    url.searchParams.delete('demo');
    window.history.replaceState(window.history.state, '', url);
    void (async () => {
      if (step !== 'login') await signOut();
      await demoLogin(supabase, persona);
    })();
  }, [step, supabase, signOut]);
  return null;
}
